import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import SpinnerCargando from "../SpinnerCargando"; // Asegúrate de tener este componente
import instanciaAxios from "../../../miscelaneo/instanciaAxios";
import { FaSearch } from "react-icons/fa";

const TablaCatalogoCuentas = ({ setCuentaSeleccionada, descripcion }) => {
  const [filtro, setFiltro] = useState("");
  const [cuentas, setCuentas] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const cargarDatos = async () => {
        try {
            setCargando(true);
            const respuesta = await instanciaAxios.get("/cuenta_contable");
            if (respuesta.status === 200) {
              setCuentas(respuesta.data);
            } else {
              console.error("Error al cargar los datos:", respuesta.statusText);
            }
            setCargando(false);
        } catch (error) {
            console.error("Error al cargar los datos:", error);
            
        }

    };

    cargarDatos();
  }, []);

  const datosFiltrados = useMemo(() => {
    if (!filtro) return cuentas;
    return cuentas.filter(
      (cuenta) =>
        cuenta.id_cuenta_contable.toString().includes(filtro) || // Convertimos a string para buscar

        cuenta.codigo.toLowerCase().includes(filtro.toLowerCase()) ||
        (cuenta.nombre?.toLowerCase() || "").includes(filtro.toLowerCase()) ||
        (cuenta.codigo?.toLowerCase() || "").includes(filtro.toLowerCase()) ||
        (cuenta.naturaleza?.toLowerCase() || "").includes(filtro.toLowerCase()) ||
        (cuenta.tipo?.toLowerCase() || "").includes(filtro.toLowerCase()) ||
        (cuenta.comentario?.toLowerCase() || "").includes(filtro.toLowerCase()) 

    );
  }, [cuentas, filtro]);

  const columns = [
    {
      name: "Código",
      selector: (row) => row.codigo,
      sortable: true,
    },
    {
      name: "Nombre",
      selector: (row) => row.nombre,
      sortable: true,
    },
    {
      name: "Naturaleza",
      selector: (row) => row.naturaleza,
      sortable: true,
    },
    {
      name: "Tipo",
      selector: (row) => row.tipo,
      sortable: true,
    },
    {
      name: "Comentario",
      selector: (row) => row.comentario,
      sortable: true,
    },
  ];

  // Función para manejar la selección de una cuenta
  const handleRowClick = (cuenta) => {
    const cuentaSeleccionada = [cuenta.id_cuenta_contable,cuenta.nombre];
    setCuentaSeleccionada(cuentaSeleccionada); // Pasa el array al componente padre
  };

  if (cargando) return <SpinnerCargando />;
  if (cuentas.length === 0) {
    return (
      <div className="text-center text-gray-500 mt-5">
        No se encontraron cuentas en el catágolo.
      </div>
    );
  }

  return (
    <DataTable
    title={
      <><h2 className="text-xl font-semibold  text-center font-cascadia text-black">
          Catálogo de Cuentas
        </h2><p className="text-sm text-gray-500 text-center ">{descripcion ? descripcion : null}</p></>
    }
      columns={columns}
      data={datosFiltrados}
      pagination
      highlightOnHover
      onRowClicked={handleRowClick} // Usamos handleRowClick para pasar la cuenta seleccionada
      dense
      subHeader
      subHeaderComponent={
        <div className="w-full relative">
          <FaSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-color-primario" />
          <input
            type="text"
            placeholder="Buscar..."
            className="w-full border px-3 py-1 rounded-xl"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
        </div>
      }
    />
  );
};

export default TablaCatalogoCuentas;
